<template>
  <div>
    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center class="px-0">
        <!-- Profile Card-->
        <v-flex
          md3
          class="hidden-sm-and-down"
          sticky-container
          style="margin-top: 200px"
        >
          <div v-sticky sticky-offset="offsetQuickMenu">
            <quick-menu />
          </div>
        </v-flex>

        <!-- Feeds-->
        <v-flex xs9 md6 style="max-width: 620px !important">
          <v-container fluid ma-0 pa-0>
            <v-layout row wrap justify-center>
              <feed-filter-button />

              <v-btn
                height="50"
                min-width="50"
                dark
                class="ml-5 mb-4 px-0"
                color="defaultColor"
                elevation="0"
                outlined
                bottom
                left
                fixed
                @click="scrollTopButtonClick"
              >
                <v-icon class="mx-0">mdi-arrow-up</v-icon>
              </v-btn>
              <!-- Story banner start -->
              <v-flex xs12 md12>
                <story-banner></story-banner>
              </v-flex>
              <!-- Story banner end -->

              <!-- Quickly Create Post -->
              <!--<quickly-create-post-card/>-->
              <!-- Quickly Create Post -->

              <v-flex xs12 md12 class="homeFeedContainer">
                <div
                  id="firstDiagno"
                  v-for="(item, index) in feedItems"
                  :key="index"
                >
                  <feed-item-card
                    class="test-diagno mb-5"
                    :itemData="item"
                    :index="index"
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>

        <v-flex md3 class="hidden-sm-and-down" sticky-container> </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import UserService from "../../services/UserService";
import FeedItemCard from "../../components/Feeds/FeedItemCard.vue";
import FeedFilterButton from "../../components/Feeds/FeedFilterButton.vue";
import StoryBanner from "../../components/Stories/StoryBanner.vue";
import QuickMenu from "../../components/Menu/QuickMenu.vue";

export default {
  data: () => {
    return {
      offsetQuickMenu: { top: 130 },
      offsetPosts: { top: -810 },

      //////
      loading: false,
      activeTab: 1,
      corporateData: [],
      individualData: [],
      searchText: "",
      refreshing: false,
      posts: [],
      stories: [],

      loading: false,
      page: 1,
      per_page: 15,
      paginationStop: false,
    };
  },
  components: {
    FeedItemCard,
    StoryBanner,
    FeedFilterButton,
    QuickMenu,
  },
  methods: {
    getFeedItems() {
      this.loading = true;
      setPageLoading(true);
      let body = {
        oldData: this.feedItems,
        page: this.page,
        perPage: this.per_page,
      };
      this.getPosts(body)
        .then((res) => {
          if (res.length == 0) this.paginationStop = true;
        })
        .catch(() => {})
        .then(() => {
          this.loading = false;
          setPageLoading(false);
        });
    },

    paginationPage() {
      console.log("paginationPage");
      this.page++;
      this.getFeedItems();
    },

    //Infinite scroll
    scrollTop(e) {
      if (!this.loading) {
        if (
          window.innerHeight + window.scrollY >=
          document.body.offsetHeight - 100
        ) {
          if (!this.paginationStop) this.paginationPage();
        }
      }
    },

    scrollTopButtonClick() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },

    ...mapActions(["getPosts"]),
  },
  computed: {
    ...mapState(["user", "feedItems"]),
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollTop);
  },
  mounted() {
    this.getFeedItems();
    window.addEventListener("scroll", this.scrollTop);
  },
  watch: {
    // shareResult (newVal, oldVal) {
    //   if (newVal && newVal.status === 'success') {
    //     // console.log("SHARE WATCH", this.diagnos[newVal.index])
    //     console.log('SHARE WATCH', newVal)
    //     this.diagnos[newVal.index].feed.sharedCount++
    //     this.$store.state.shareResult = null
    //   }
    // }
  },
};
</script>

<style>
.fixed .v-card {
  position: fixed;
  min-width: 253.5px;
}

.fixed-in-flex {
  position: fixed;
}

.vue-sticky-el {
  z-index: 1 !important;
}

.word-wrap {
  word-break: break-word !important;
}
</style>
